import React from "react";
import { Link } from "gatsby";

export default function CallToAction(props) {
  return (
    <div className="flex flex-row justify-center pt-8">
      {props.data && (
        <Link
          className="call-to-action"
          to={props.data && props.data.buttonLinkUrl}
        >
          <button className={``}>{props.data.buttonText}</button>
        </Link>
      )}
    </div>
  );
}
